const AUTH_TOKEN_KEY = "@aquarius-auth-token-key/v2"

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY)
export const storeAuthToken = token => localStorage.setItem(AUTH_TOKEN_KEY, token)
export const removeAuthToken = () => localStorage.removeItem(AUTH_TOKEN_KEY)
export const isAuthenticated = () => getAuthToken() !== null
